// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"

import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CONSTANT from "../../../constant"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"

import { useEffect, useState } from "react"
import { TZyomuinSyukkinboDigitachoKintaiRes } from "../../../service/attendance/syukkinbo_v2/TZyomuinSyukkinbo"
import DateInput from "../../../components/InputWrapper/DateInput"

const DigitachoGrid: React.FC<{
  年月: string
  gridId: string
  isRestoreSearching: boolean
  setIsRestoreSearching: React.Dispatch<React.SetStateAction<boolean>>
  digiTachoGridData: {
    data: wjCore.CollectionView
  }
  setDigiTachoGridData: React.Dispatch<
    React.SetStateAction<{
      data: wjCore.CollectionView
    }>
  >
}> = (props) => {
  const [digiTachoFlexGrid, setDigiTachoFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [digiTachoPageSize, setDigiTachoPageSize] = useState<number>(0)
  const [digiTachoGridInitialized, setDigiTachoGridInitialized] =
    useState<boolean>(false)

  const 始業月初日 = dayjs(props.年月).startOf("month").toISOString()
  const 始業月末日 = dayjs(props.年月).endOf("month").toISOString()

  const [始業日, set始業日] = useState<string | null | undefined>(始業月初日)

  // グリッド初期化時イベントハンドラ
  const digiTachoGridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.refresh()
  }

  useEffect(() => {
    if (props?.digiTachoGridData?.data == null || digiTachoFlexGrid == null)
      return
    props.digiTachoGridData.data.pageSize = 0
    props.digiTachoGridData.data.filter = (
      item: TZyomuinSyukkinboDigitachoKintaiRes
    ) => {
      const dayjs始業日付 = dayjs(item.始業日付)
      const dayjs始業日 = dayjs(始業日)

      return dayjs始業日付.diff(dayjs始業日, "day") >= 0
    }
    digiTachoFlexGrid.refresh()
  }, [digiTachoFlexGrid, props.digiTachoGridData.data, 始業日])

  return (
    <div>
      <div className="">
        <span>始業日</span>
        <div className="w-13rem d-inline-block">
          <DateInput
            id="始業日"
            placeholder=""
            isRequired={true}
            has1DayButton={true}
            showHoliday={true}
            value={始業日}
            min={始業月初日}
            max={始業月末日}
            defaultValue={始業月初日}
            setValue={(v) => {
              set始業日(v)
            }}></DateInput>
        </div>
        <span>以降</span>
      </div>
      <FlexGridOuter
        flexGrid={digiTachoFlexGrid}
        setFlexGrid={setDigiTachoFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={props.digiTachoGridData}
        setGridData={props.setDigiTachoGridData}
        pageNumber={0}
        gridId={`${props.gridId}_2`}
        isRestoreSearching={props.isRestoreSearching}
        setIsRestoreSearching={props.setIsRestoreSearching}
        gridInitialized={digiTachoGridInitialized}
        setGridInitialized={setDigiTachoGridInitialized}
        isShowGridFooter={false}
        pageSize={digiTachoPageSize}
        setPageSize={setDigiTachoPageSize}
        gridInitializedHandler={digiTachoGridInitializedHandler}
        isShowGridRowPickupButton={false}
        hasFilter={false}
        gridProperties={{
          allowSorting: wjcGrid.AllowSorting.None,
          allowDragging: wjcGrid.AllowDragging.None,
        }}>
        <wjrGrid.FlexGridColumn
          binding="始業日"
          cssClass="read-only-cell"
          width={70}
          align={"center"}
          header="始業日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TZyomuinSyukkinboDigitachoKintaiRes>
            ) => {
              let dt = ""
              if (context.item.始業日付)
                dt = dayjs(context.item.始業日付).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str始業時刻"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="始業"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="終業日"
          cssClass="read-only-cell"
          width={70}
          align={"center"}
          header="終業日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TZyomuinSyukkinboDigitachoKintaiRes>
            ) => {
              let dt = ""
              if (context.item.終業日付)
                dt = dayjs(context.item.終業日付).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str終業時刻"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="終業"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str勤務時間"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="勤務"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str残業時間"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="残業"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str深夜時間"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="深夜"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str休憩時間"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="休憩"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str休息時間"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="休息"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str拘束時間"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="拘束"></wjrGrid.FlexGridColumn>

        <wjrGrid.FlexGridColumn
          binding="str荷積時間"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="荷積"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str荷卸時間"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="荷卸"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="str待機時間"
          cssClass="read-only-cell"
          width={80}
          align={"center"}
          header="待機"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="走行距離"
          cssClass="read-only-cell"
          width={80}
          header="走行距離"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="通行料合計"
          format={"C0"}
          cssClass="read-only-cell"
          width={90}
          header="通行料"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>
    </div>
  )
}

export default DigitachoGrid
